import axios from "axios";
import { BASE_URL_ROUTER } from "../../Config/BaseUrl";
import Swal from "sweetalert2";
import {
  CREATE_HOLIDAY_REQUEST,
  CREATE_HOLIDAY_SUCCESS,
  CREATE_HOLIDAY_FAILURE,
  GET_HOLIDAY_REQUEST,
  GET_HOLIDAY_SUCCESS,
  GET_HOLIDAY_FAILURE,
  DELETE_HOLIDAY_REQUEST,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAILURE,
  UPDATE_HOLIDAY_REQUEST,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAILURE,
} from "../../Constants/school_user/HolidayMaster";

export const createHoliday = (token, getHoliday, navigate, resetForm) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_HOLIDAY_REQUEST });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios.post(
        `${BASE_URL_ROUTER}holiday_master_api/`,
        getHoliday,
        config
      );
      const data = response.data;
      dispatch({ type: CREATE_HOLIDAY_SUCCESS, payload: data });
      if (response.data.status === 200) {
        Swal.fire({
          text: response.data.msg,
          icon: "success",
          imageAlt: "success image",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/school/holiday-master");
            resetForm();
          }
        });
      }
      if (response.data.status === 403) {
        Swal.fire({
          text: response.data.msg,
          icon: "error",
          imageAlt: "error image",
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_HOLIDAY_FAILURE,
        payload: error,
      });
    }
  };
};

export const getHolidayList = (token, s_id, session_id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_HOLIDAY_REQUEST });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios.get(
        `${BASE_URL_ROUTER}holiday_master_api/?school_id=${s_id}&fk_academic=${session_id}`,

        config
      );
      const data = response.data;
      dispatch({ type: GET_HOLIDAY_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_HOLIDAY_FAILURE,
        payload: error,
      });
    }
  };
};

export const deleteHoliday = (token, ID) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DELETE_HOLIDAY_REQUEST });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios.delete(
        `${BASE_URL_ROUTER}holiday_master_api/${ID}/`,
        config
      );
      const data = response.data;
      dispatch({ type: DELETE_HOLIDAY_SUCCESS, payload: data });
      if (response.data.status === 200) {
        Swal.fire({
          text: response.data.msg,
          icon: "success",
          imageAlt: "success image",
        });
      }
      if (response.data.status === 403) {
        Swal.fire({
          text: response.data.msg,
          icon: "error",
          imageAlt: "error image",
        });
      }
    } catch (error) {
      dispatch({
        type: DELETE_HOLIDAY_FAILURE,
        payload: error,
      });
    }
  };
};

export const updateHoliday = (token, u_id, staff, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_HOLIDAY_REQUEST });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios.patch(
        `${BASE_URL_ROUTER}holiday_master_api/${u_id}/`,
        staff,
        config
      );
      const data = response.data;
      dispatch({ type: UPDATE_HOLIDAY_SUCCESS, payload: data });
      if (response.data.status === 200) {
        Swal.fire({
          text: response.data.msg,
          icon: "success",
          imageAlt: "success image",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/school/holiday-master");
          }
        });
      }
      if (response.data.status === 403) {
        Swal.fire({
          text: response.data.msg,
          icon: "error",
          imageAlt: "error image",
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_HOLIDAY_FAILURE,
        payload: error,
      });
    }
  };
};
